export const getOptionsFromState = (
  selectQueryOptions,
  getState,
  sendLimit = true
) => {
  const queryOpts = selectQueryOptions(getState());
  const reqOptions = {};

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (queryOpts.year) {
    reqOptions.year = queryOpts.year;
  }
  if (queryOpts.month) {
    reqOptions.month = queryOpts.month;
  }
  if (sendLimit) {
    reqOptions.limit = queryOpts.limit;
  }

  return reqOptions;
};

export default getOptionsFromState;
